import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { palette } from '@m12s/component-library';

const SwitchWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 2.5rem;
  height: 1.5rem;
  cursor: ${({ disabled }) => {
    return disabled ? 'not-allowed' : 'pointer';
  }};
`;

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const Slider = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${palette.Grey400};
  transition: 0.4s;
  border-radius: 2rem;

  &:before {
    position: absolute;
    content: '';
    height: 0.875rem;
    width: 0.875rem;
    left: 0.3125rem;
    bottom: 0.3125rem;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${({ isChecked }) => {
    return (
      isChecked &&
      `
      background-color: ${palette.Indigo600};
      &:before {
        transform: translateX(0.875rem);
      }
    `
    );
  }}
`;

const SwitchToggle = ({ isChecked, onChange, disabled }) => {
  return (
    <SwitchWrapper disabled={disabled}>
      <SwitchInput
        type="checkbox"
        checked={isChecked}
        onChange={disabled ? undefined : onChange}
        disabled={disabled}
      />
      <Slider isChecked={isChecked} />
    </SwitchWrapper>
  );
};

SwitchToggle.propTypes = {
  isChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SwitchToggle.defaultProps = {
  isChecked: false,
  disabled: false,
};

export default SwitchToggle;
